import { createAction } from 'effector-action'

import { $portalProfile } from '@/entities/profile/portal'
import { analytics } from '@/shared/lib/analytics'

createAction({
    clock: $portalProfile,
    target: { trackLogin: analytics.login },
    fn: ({ trackLogin }, profile) => {
        if (profile !== null && profile.publicId !== '') {
            trackLogin(profile)
        }
    },
})
